/* eslint-disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".root_c696b4a6{display:inline-block;vertical-align:middle;speak:none;width:1em;height:1em}.svg_c696b4a6{height:100%;fill:currentColor;vertical-align:top}"}]);
export const root = "root_c696b4a6";
export const svg = "svg_c696b4a6";